import React, {
  useContext,
  useLayoutEffect,
  useReducer,
  useState,
} from "react";
import Slider from "react-slick";
import Tilt from "react-tilt";
import throttle from "lodash.throttle";
import once from "lodash.once";

import "./style.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import data from "./data"
import { FigCaption } from "./figcaption";
import { LanguageContext, text } from "../../container/language";
import { useTranslation } from "react-i18next";

// initial state for the sliderReducer hook

const initialState = {
  slider: {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 0,
    swipe: true,
    swipeToSlide: true,
    rows: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          rows: 3,
          slidesToScroll: 0,
          dots: true,
        },
      },
    ],
  },
  tilt: {
    max: 15,
    scale: 1,
    perspective: 2000,
  },
};

// Hooks

const useWindowSize = (dispatch) => {
  useLayoutEffect(() => {
    function updateSize() {
      let type = "DESKTOP_VERSION";
      if (window.innerWidth <= 600) {
        type = "PHONE_VERSION";
      } else if (window.innerWidth <= 950) {
        type = "TABLET_VERSION";
      }

      dispatch({ type, width: window.innerWidth });
    }

    const throttledUpdate = throttle(updateSize, 1000);
    window.addEventListener("resize", throttledUpdate);
    once(updateSize)();
    return () => window.removeEventListener("resize", throttledUpdate);
  }, []);
};

const sliderReducer = (state, action) => {
  switch (action.type) {
    case "PHONE_VERSION": {
      const { slider, tilt } = state;
      return { slider, tilt: { ...tilt, max: 0, perspective: 1e5 } };
    }
    case "TABLET_VERSION": {
      const { slider, tilt } = state;
      return { slider, tilt: { ...tilt, max: 0, perspective: 1e5 } };
    }
    case "DESKTOP_VERSION":
      return initialState;
    default:
      return state;
  }
};

const SelectedBlock = ({ data }) => {
  const { articleCards = [], title } = data;
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();
  const [sliderState, dispatch] = useReducer(sliderReducer, initialState);
  useWindowSize(dispatch);

  return (
    <>
      <div className="site-block__title site-block__title--small">
        <div className="site-block__title-left">
          {text(title, userLanguage)}
        </div>
      </div>
      <Slider className="selected-slider" {...sliderState.slider}>
        {articleCards.map((item) => (
          <Tilt key={item.id} options={{ ...sliderState.tilt }}>
            <FigCaption {...item} />
          </Tilt>
        ))}
      </Slider>
    </>
  );
};

export default SelectedBlock;
